// extracted by mini-css-extract-plugin
export default {"preloadedFromContainer":"useMachineManagementShortcutReceiver_preloadedFromContainer__iFuZ1","cancelPreload":"useMachineManagementShortcutReceiver_cancelPreload__Hl5ov"};